document.addEventListener("DOMContentLoaded", () => {

  
  // const default_json = [
  //   {
  //   question: "Are you looking for positional feedback?",
  //   answers: ["Yes", "No"],
  //   followUps: [
  //     {
  //       question: "Do you need high precision?",
  //       answers: ["Yes (±100µm accuracy)", "No (±3mm accuracy)"],
  //       followUps: [
  //         {
  //           question: "Which type of communication protocol?",
  //           answers: ["TTL/PWM", "RS-485"],
  //           products: ["micro-servo-actuator-ttl", "micro-servo-actuator-rs485"]
  //         },
  //         {
  //           question: "How much force will you need?",
  //           answers: ["≤ 150 lbs", "> 150 lbs, ≤ 450 lbs"],
  //           followUps: [{
  //               question: "Do you need outdoor dust and water ingress protection ratings?",
  //               answers: ["Yes", "No"],
  //               products: ["pa-10-hall", "linear-actuator-with-potentiometer"]
  //             },
  //             {
  //               question: "Do you need outdoor dust and water ingress protection ratings?",
  //               answers: ["Yes", "No"],
  //               products: ["pa-10-hall", "pa-10-hall"]
  //             }
  //           ]
  //         }
  //       ]
  //     },
  //     {
  //       question: "What are your stroke length requirements?",
  //       answers: ['≤ 8"', '>8", ≤ 12"', '>12", ≤ 36"', '>36",≤ 40"'],
  //       followUps: [
  //         // '≤ 8"'
  //         {
  //           question: "How much force will you need?",
  //           answers: ["≤ 5 lbs", "> 5 lbs, ≤ 39 lbs", "> 39 lbs, ≤ 150 lbs", "> 150 lbs, ≤ 450 lbs"],
  //           followUps: [{
  //               question: "Do you need outdoor dust and water ingress protection ratings?",
  //               answers: ["Yes", "No"],
  //               followUps: [{
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['≤ 1.18"/sec', '> 1.18"/sec, ≤ 2.95"/sec'],
  //                   products: ["micro-linear-actuator//pa-mc1", "pa-01"]
  //                 },
  //                 {
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['≤ 1.18"/sec', '> 1.18"/sec, ≤ 2.95"/sec'],
  //                   products: ["micro-linear-actuator//pa-mc1", "mini-linear-actuator//pa-01"]
  //                 }
  //               ]
  //             },
  //             {
  //               question: "Do you need outdoor dust and water ingress protection ratings?",
  //               answers: ["Yes", "No"],
  //               followUps: [{
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['≤ 1.18"/sec', '> 1.18"/sec, ≤ 2.95"/sec'],
  //                   products: ["pa-mc1", "pa-01"]
  //                 },
  //                 {
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['≤ 1.18"/sec', '> 1.18"/sec, ≤ 2.95"/sec'],
  //                   products: ["pa-mc1", "mini-linear-actuator//pa-01"]
  //                 }
  //               ]
  //             },
  //             {
  //               question: "Do you need outdoor dust and water ingress protection ratings?",
  //               answers: ["Yes", "No"],
  //               followUps: [{
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['≤ 0.33"/sec', '> 0.33"/sec, ≤ 2.95"/sec'],
  //                   products: ["pa-10//mini-medium-force-linear-actuator", "pa-01"]
  //                 },
  //                 {
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['≤ 0.33"/sec', '> 0.33"/sec, ≤ 2.95"/sec'],
  //                   products: ["pa-10//mini-medium-force-linear-actuator", "mini-linear-actuator//pa-01"]
  //                 }
  //               ]
  //             },
  //             {
  //               question: "What is the full load travel speed range you need?",
  //               answers: ['≤ 0.33"/sec (450 lbs max)', '> 0.33"/sec (225 lbs max)'],
  //               products: ["pa-10//mini-medium-force-linear-actuator", "pa-01"]
  //             }
  //           ]
  //         },
  //         // '>8", ≤ 12"'
  //         {
  //           question: "How much force will you need?",
  //           answers: ["≤ 5 lbs", "> 5 lbs, ≤ 150 lbs", "> 150 lbs, ≤ 450 lbs"],
  //           followUps: [
  //             // "≤ 5 lbs"
  //             {
  //               question: "Do you need outdoor dust and water ingress protection ratings?",
  //               answers: ["Yes", "No"],
  //               followUps: [{
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['≤ 0.55"/sec', '> 0.55"/sec, ≤ 2.95"/sec'],
  //                   products: ["micro-linear-actuator", "pa-01"]
  //                 },
  //                 {
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['≤ 0.55"/sec', '> 0.55"/sec, ≤ 2.95"/sec'],
  //                   products: ["micro-linear-actuator//pa-mc1", "mini-linear-actuator//pa-01"]
  //                 }
  //               ]
  //             },
  //             // "> 5 lbs, ≤ 150 lbs"
  //             {
  //               question: "Do you need outdoor dust and water ingress protection ratings?",
  //               answers: ["Yes", "No"],
  //               followUps: [{
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['≤ 0.33"/sec', '> 0.33"/sec, ≤ 2.95"/sec'],
  //                   products: ["pa-10//mini-medium-force-linear-actuator", "pa-01"]
  //                 },
  //                 {
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['≤ 0.33"/sec', '> 0.33"/sec, ≤ 2.95"/sec'],
  //                   products: ["pa-10//mini-medium-force-linear-actuator", "mini-linear-actuator//pa-01"]
  //                 }
  //               ]
  //             },
  //             // "> 150 lbs, ≤ 450 lbs"
  //             {
  //               question: "What is the full load travel speed range you need?",
  //               answers: ['≤ 0.33"/sec (450 lbs max)', '> 0.33"/sec (225 lbs max)'],
  //               products: ["pa-10//mini-medium-force-linear-actuator", "pa-01"]
  //             }

  //           ]
  //         },
  //         // '>12", ≤ 36"'
  //         {
  //           question: "How much force will you need?",
  //           answers: ["≤ 150 lbs", "> 150 lbs, ≤ 450 lbs"],
  //           followUps: [
  //             // "≤ 150 lbs"
  //             {
  //               question: "Do you need outdoor dust and water ingress protection ratings?",
  //               answers: ["Yes", "No"],
  //               followUps: [{
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['> 0.27"/sec (max 450 lbs)', '≤ 0.27"/sec (max 330 lbs)'],
  //                   products: ["pa-10", "mini-medium-force-linear-actuator"]
  //                 },
  //                 {
  //                   question: "What is the full load travel speed range you need?",
  //                   answers: ['≤ 0.33"/sec', '> 0.33"/sec, ≤ 1.38"/sec'],
  //                   products: ["pa-10//mini-medium-force-linear-actuator", "mini-linear-actuator"]
  //                 }
  //               ]
  //             },
  //             // "> 150 lbs, ≤ 450 lbs"
  //             {
  //               question: "What is the full load travel speed range you need?",
  //               answers: ['> 0.27"/sec (max 450 lbs)', '≤ 0.27"/sec (max 330 lbs)'],
  //               products: ["pa-10", "mini-medium-force-linear-actuator"]
  //             }

  //           ]
  //         },
  //         // '>36",≤ 40"'
  //         {
  //           question: "How much force will you need?",
  //           answers: ["≤ 150 lbs", "> 150 lbs, ≤ 330 lbs"],
  //           followUps: [
  //             // "≤ 150 lbs"
  //             {
  //               question: "Do you need outdoor dust and water ingress protection ratings?",
  //               answers: ["Yes", "No"],
  //               products: ["mini-medium-force-linear-actuator", "mini-linear-actuator"]
  //             },
  //             // "> 150 lbs, ≤ 330 lbs"
  //             {
  //               question: "Do you need outdoor dust and water ingress protection ratings?",
  //               answers: ["Yes", "No"],
  //               products: ["mini-medium-force-linear-actuator", "mini-medium-force-linear-actuator"]
  //             }
  //           ]
  //         }
  //       ]
  //     }
  //   ]
  // }
  // ]; // backup 
  
   let currentQuestionIndex = 0;
  let recommendedProducts = [];
  const displayedQuestions = [...questions];

  const quiz_headerEl = document.querySelector('.quiz_header');
  const questionElement = document.getElementById("question");
  const answersElement = document.getElementById("answers");
  const resultElement = document.getElementById("result");
  const progressElement = document.getElementById("progress");
  const progressPercentCount = document.getElementById("progress-percent");
  const prevButton = document.getElementById("prev-btn");
  const resetButton = document.getElementById("reset-btn");
  const result_product_blocks = resultElement.querySelectorAll('.result_product_block');
  const progressBarWrapper = document.querySelector('.progress-bar-wrapper');
  const question_tooltipBtn = document.querySelector('.question-popup-modal__opener');
  const questionTooltipModalEl = document.querySelectorAll('.question-popup-modal');

  function toHandle(str) {
  return str
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, '-') 
    .replace(/[^a-z0-9\-]/g, '');
}
  
  function loadQuestion() {
    const questionData = displayedQuestions[currentQuestionIndex];
    questionElement.textContent = questionData.question;
    answersElement.innerHTML = '';
    
    question_tooltipBtn.classList.add('hide');
    questionTooltipModalEl.forEach((modal, index) => {
      const modal_id = modal.getAttribute('data-question_id');
      const question_handle = toHandle(questionData.question);

      if(question_handle == modal_id) {
        question_tooltipBtn.classList.remove('hide');
        question_tooltipBtn.setAttribute('data-modal',`#`+modal.id);
      }
    });

    questionData.answers.forEach((answer, index) => {
      const button = document.createElement("button");
      button.textContent = answer;
      button.className = "answer-btn";
      button.dataset.btn_index = index;
      button.onclick = () => handleAnswer(index);
      answersElement.appendChild(button);
    });

    updateProgress();
    updateControls();
  }

  function handleAnswer(index) {
    const questionData = displayedQuestions[currentQuestionIndex];
  
    if (questionData.products) {
      recommendedProducts.push(questionData.products[index]);
    }
  
    if (questionData.followUps && questionData.followUps[index]) {
      const followUp = questionData.followUps[index];
  
      const isAlreadyAdded = displayedQuestions.some(q => q.question === followUp.question);
  
      if (!isAlreadyAdded) {
        displayedQuestions.splice(currentQuestionIndex + 1, 0, followUp);
      }
    }
    
    if (currentQuestionIndex < displayedQuestions.length - 1) {
      currentQuestionIndex++;
      loadQuestion();
    } else {
      currentQuestionIndex++;
      updateProgress();
      showResult();
    }
  }

  function updateProgress() {
    const progressPercent = (currentQuestionIndex / displayedQuestions.length) * 100;
    progressElement.style.width = `${progressPercent}%`;
    progressPercentCount.innerHTML = Math.round(progressPercent) + "%";
  }

  function updateControls() {
    prevButton.disabled = currentQuestionIndex === 0;
    resetButton.disabled = currentQuestionIndex === 0;
  }

  function hideResult() {
    result_product_blocks.forEach(product_block => {
      product_block.classList.add('hide');
    });
    answersElement.classList.remove('hide');
    resultElement.classList.add('hide');
    quiz_headerEl.classList.remove('hide');
    progressBarWrapper.classList.remove('hide');
    recommendedProducts = [];
  }

  function showResult() {
    const containsDoubleSlash = recommendedProducts.some(item => item.includes('//'));
    if (containsDoubleSlash) {
      recommendedProducts = recommendedProducts.join('//').split('//');
    }
    
    recommendedProducts.forEach(handle => {
      result_product_blocks.forEach(product_block => {
        const product_block_handle = product_block.getAttribute('data-handle');
        if (product_block_handle == handle) {
          product_block.classList.remove('hide');
        }
      });
    });

    resultElement.classList.remove('hide');
    answersElement.classList.add('hide');
    quiz_headerEl.classList.add('hide');
    progressBarWrapper.classList.add('hide');
  }
   
  prevButton.onclick = () => {
    if (currentQuestionIndex > 0) {
      currentQuestionIndex--;
      displayedQuestions.splice(currentQuestionIndex + 1);
      loadQuestion();
      hideResult();
    }
  };

  resetButton.onclick = () => {
    if (currentQuestionIndex > 0) {
      currentQuestionIndex = 0;
      displayedQuestions.splice(0, displayedQuestions.length, ...questions);
      loadQuestion();
      hideResult();
    }
  };

  loadQuestion();
});